import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import TotpEnrolWizard from "@/components/TotpEnrolWizard";
import TotpVerifyPrompt from "@/components/TotpVerifyPrompt";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-slate-500" data-testid="auth-loading">Authenticating…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  // Iter 86d — Mandatory 2FA gates. The backend returns `totp_state`
  // on /auth/me; we render the enrolment wizard or verify prompt FULL-
  // SCREEN before letting the user into the app. AuthContext.checkAuth
  // is called from each component on success so the app un-gates.
  if (user.totp_state === "setup_required") return <TotpEnrolWizard />;
  if (user.totp_state === "verify_required") return <TotpVerifyPrompt />;
  return children;
}
